import React from 'react';
import { Box, Stack, useTheme } from '@mui/material';
import NotesIcon from '@mui/icons-material/Notes';
import StatusCard from './StatusCard';
import JobActions from './JobActions';
import JobDocuments from './JobDocuments';
import EditableTextSection from './EditableTextSection';
import { surfaceCard } from '../../../../Shared/surfaceCard';

const JobSidebar = ({
	jobId,
	bidDetails,
	notes,
	isEditingNotes,
	onNotesToggle,
	onNotesChange,
	onNotesConfirm,
	onJobUpdated,
}) => {
	const theme = useTheme();

	return (
		<Stack
			spacing={2.5}
			sx={{
				position: { lg: 'sticky' },
				top: { lg: 24 },
			}}
		>
			<Box
				sx={{
					'& .MuiCard-root': {
						...surfaceCard(theme),
						mb: 0,
						boxShadow: 'none',
					},
					'& .MuiCard-root + .MuiCard-root, & .MuiBox-root > .MuiCard-root': {
						mt: 2.5,
					},
				}}
			>
				<StatusCard onJobUpdated={onJobUpdated} />
				<JobActions jobId={jobId} onJobUpdated={onJobUpdated} />
			</Box>
			<Box sx={{ display: { xs: 'none', lg: 'block' } }}>
				<EditableTextSection
					icon={NotesIcon}
					title="Notes"
					value={notes}
					placeholder="No notes provided."
					isEditing={isEditingNotes}
					onToggleEdit={onNotesToggle}
					onChange={onNotesChange}
					onConfirm={onNotesConfirm}
				/>
			</Box>
			<Box sx={{ display: { xs: 'block', lg: 'none' } }}>
				<JobDocuments
					variant="sidebar"
					proposalPdfUrl={bidDetails?.proposal_pdf_url}
					invoicePdfUrl={bidDetails?.invoice_pdf_url}
				/>
			</Box>
		</Stack>
	);
};

export default JobSidebar;
